// extracted by css-extract-rspack-plugin
export default {"SignupForm":"SignupForm-tFvKpM","signupForm":"SignupForm-tFvKpM"};